import { useAppNavigation } from "src/contexts/AppNavigationContext";
import { FC, useEffect } from "react";

import "./Overlay.scss";

const Overlay: FC = () => {
    const { isOpen, isDesktop, drawerItems, closeMobileDrawer } = useAppNavigation();
    const visible = !isDesktop && isOpen && drawerItems.length > 0;
    useEffect(() => {
        if (!visible) return;
        const onKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape") closeMobileDrawer();
        };
        document.addEventListener("keydown", onKeyDown);
        return () => document.removeEventListener("keydown", onKeyDown);
    }, [visible, closeMobileDrawer]);

    if (!visible) return null;

    return (
        <div
            className="overlay"
            onClick={closeMobileDrawer}
            aria-hidden="true"
        ></div>
    );
};

export default Overlay;
